/**
 * Created by sshu on 2020/11/19
 */
import * as API from '.';
// 根据用户id获取用户信息
export const findUserInfo = (params: object) => {
    return API.GET('/userMgr/baselogin/getLoginUserInfo', params, process.env.VUE_APP_BASEAPIURL);
};
// 获取应用列表
export const findAppList = (params: object) => {
    return API.GET('/openmgr/appinfo/getAppList', params);
};
// 应用审核
export const examineApp = (params: object) => {
    return API.GET('/openmgr/appinfo/examineApp', params);
};
// 获取api分组集合
export const findApiGroup = (params: object) => {
    return API.GET('/openmgr/apiinfo/queryApiGroup', params);
};
// 根据id获取api信息
export const findApiInfo = (params: object) => {
    return API.GET('/openmgr/apiinfo/queryApiInfo', params);
};
// 授权api
export const examineApi = (params: object) => {
    return API.GET('/openmgr/apiinfo/examineApi', params);
};
// 模糊搜索接口
export const queryApiInfoByKeyWord = (params: object) => {
    return API.GET('/openmgr/apiinfo/queryApiInfoByKeyWord', params);
};


// 【前台】注册——用户注册
export const registerUser = (params: object) => {
    return API.POST('/openmgr/user/registerUser', params);
};
// 【前台】注册——获取省市区
export const findAreaList = (params: object) => {
    return API.GET('/base/baseregion/getRegion', params, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】注册——获取腾讯验证码应用id
export const findAppId = () => {
    return API.GET('/base/verificationCode/getAppId', {}, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】注册——[第一步]获取安全码
export const findsafetyid = () => {
    return API.GET('/base/register/getsafetyid', {}, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】注册——[第二步]获取短信验证码
export const findsmscodebymobile = (params: object) => {
    return API.POST('/userMgr/register/getNewSMSCodeByMobile', params, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】注册——[第三步]校验短信验证码
export const checkMobileCode = (params: object) => {
    return API.GET('/base/register/checkMobileCode', params, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】用户登录
export const loginUser = (params: object) => {
    return API.POST('/openmgr/user/loginUser', params);
};
// 【前台】用户修改密码
export const changePassword = (params: object) => {
    return API.POST('/openmgr/user/changePassword', params);
};
// 【前台】根据用户id获取用户信息
export const getLoginUserInfo = (params: object) => {
    return API.GET('/openmgr/user/getLoginUserInfo', params);
};
// 【前台】根据字典类别获取具体的条目
export const findDictList = (params: object) => {
    return API.GET('/base/basedict/getDictList', params, process.env.VUE_APP_BASEAPIURL);
};
// 【前台】应用——申请应用
export const addOrModifyAppInfo = (params: object) => {
    return API.POST('/openmgr/appinfo/addOrModifyAppInfo', params);
};
// 【前台】应用——获取应用列表
export const getFrontAppList = (params: object) => {
    return API.GET('/openmgr/appinfo/getFrontAppList', params);
};
// 【前台】应用——根据应用id获取应用详情
export const findAppInfo = (params: object) => {
    return API.GET('/openmgr/appinfo/getAppInfo', params);
};
// 【前台】应用——根据应用id删除应用
export const deleteAppInfo = (params: object) => {
    return API.GET('/openmgr/appinfo/deleteAppInfo', params);
};
// 【前台】应用——根据应用id获取应用下已授权学校列表
export const findAuthedSchoolList = (params: object) => {
    return API.GET('/openmgr/appinfo/queryFrontAppSchoolList', params);
};
// 【前台】应用——取消应用学校授权
export const cancelAppSchool = (params: object) => {
    return API.POST('/openmgr/appinfo/cancelAppSchool', params);
};
// 【前台】应用——授权管理获取学校列表
export const findSchoolList = (params: object) => {
    return API.GET("/openmgr/appinfo/getChoiceSchoolList", params)
}
// 【前台】应用——授权管理获取区域列表
export const findPlatformList = (params: object) => {
    return API.GET("/openmgr/appinfo/getChoicePlatformList", params)
}
// 【前台】应用——授权管理申请应用学校授权
export const applyAppSchool = (params: object) => {
    return API.POST("/openmgr/appinfo/applyAppSchool", params)
}
// 【前台】应用——根据应用id获取应用下已申请API列表
export const findAuthedAPIList = (params: object) => {
    return API.GET("/openmgr/appinfo/queryFrontAppApiList", params)
}
// 【前台】应用——申请API获取API列表
export const findAPIList = (params: object) => {
    return API.GET("/openmgr/apiinfo/getApiApplyList", params)
}
// 【前台】应用——API申请
export const applyAppApi = (params: object) => {
    return API.POST("/openmgr/appinfo/applyAppApi", params)
}
// 【前台】应用——取消API申请
export const cancelAppApi = (params: object) => {
    return API.POST("/openmgr/appinfo/cancelAppApi", params)
}
// 【前台】分组——获取分组列表
export const findGroupList = (params: object) => {
    return API.GET("/openmgr/apiinfo/getGroupList", params)
}
// 【前台】文档——获取文档分组树型结构
export const findApiGroupList = (params: object) => {
    return API.GET("/openmgr/apiinfo/getApiGroupList", params)
}
// 【前台】文档——根据分组id获取接口列表
export const findApiListByGroupId = (params: object) => {
    return API.GET("/openmgr/apiinfo/getFrontApiInfo", params)
}
// 【前台】文档——根据API id获取接口详情
export const findApiInfoById = (params: object) => {
    return API.GET("/openmgr/apiinfo/getApiInfoDetail", params)
}
// 【前台】文档——根据API id获取接口参数说明
export const findApiParamsById = (params: object) => {
    return API.GET("/openmgr/apiinfo/getApiParam", params)
}
// 【前台】文档——根据API id获取接口返回值
export const findApiReturnDataById = (params: object) => {
    return API.GET("/openmgr/apiinfo/queryApiReturn", params)
}
// 【前台】应用——修改数据推送地址
export const updateDataPushUrl = (params: object) => {
    return API.POST("/openmgr/appinfo/updateDataPushUrl", params)
}
// 【前台】主页——企业信息维护
export const saveUserDetail = (params: object) => {
    return API.POST("/openmgr/user/saveUserDetail", params)
}
// 【前台】主页——获取上线提示信息
export const findUpdateContent = () => {
    return API.GET("/openmgr/user/platformMaintain", {})
}
// 【后台】获取用户列表
export const findEnterpriseList = (params: object) => {
    return API.GET('/openmgr/user/getEnterpriseList', params);
};
// 【后台】用户审核
export const examineEnterprise = (params: object) => {
    return API.GET('/openmgr/user/examineEnterprise', params);
};
// 【后台】数据推送地址审核
export const examineDataPush = (params: object) => {
    return API.GET('/openmgr/appinfo/examineDataPush', params);
};
// 【后台】获取应用学校列表
export const findAuthSchoolListByAppId = (params: object) => {
    return API.GET('/openmgr/appinfo/queryAppSchoolList', params);
};
// 【后台】审核学校授权
export const batchExamineAppSchool = (params: object) => {
    return API.GET('/openmgr/appinfo/batchExamineAppSchool', params);
};
// 【后台】根据应用id获取应用下申请API列表
export const findApplyAPIListByAppId = (params: object) => {
    return API.GET('/openmgr/appinfo/queryAppApiList', params);
};
// 【后台】审核接口申请
export const examineAppApi = (params: object) => {
    return API.GET('/openmgr/appinfo/examineAppApi', params);
};
// 【后台】获取API接口列表
export const queryApiInfoList = (params: object) => {
    return API.GET('/openmgr/apiinfo/queryApiInfoList', params);
};
// 【后台】获取API接口列表
export const deleteApiById = (params: object) => {
    return API.GET('/openmgr/apiinfo/deleteApiInfo', params);
};
// 【后台】新增、修改API接口
export const addOrModifyApiInfo = (params: object) => {
    return API.GET('/openmgr/apiinfo/addOrModifyApiInfo', params);
};
// 【后台】删除API接口参数
export const deleteApiParam = (params: object) => {
    return API.GET('/openmgr/apiinfo/deleteApiParam', params);
};
// 【后台】新增、修改API接口参数
export const addOrModifyApiParam = (params: object) => {
    return API.GET('/openmgr/apiinfo/addOrModifyApiParam', params);
};
// 【后台】删除分组
export const deleteApiGroup = (params: object) => {
    return API.GET('/openmgr/apiinfo/deleteApiGroup', params);
};
// 【后台】新增、修改分组
export const addOrModifyApiGroup = (params: object) => {
    return API.GET('/openmgr/apiinfo/addOrModifyApiGroup', params);
};
// 【后台】新增、删除API接口返回值
export const deleteApiReturnParam = (params: object) => {
    return API.GET('/openmgr/apiinfo/deleteApiReturn', params);
};
// 【后台】新增、修改API接口返回值
export const addOrModifyApiReturnParam = (params: object) => {
    return API.GET('/openmgr/apiinfo/addOrModifyApiReturn', params);
};
// 【后台】获取敏感字段
export const getSensitiveFields = (params: object) => {
    return API.GET('/openmgr/apiinfo/getSensitiveFields', params);
};
// 【后台】设置应用学校敏感字段
export const setAppApiSensitiveField = (params: object) => {
    return API.GET('/openmgr/apiinfo/setAppApiSensitiveField', params);
};
// 【后台】获取应用学校敏感字段
export const getAppApiSensitiveFields = (params: object) => {
    return API.GET('/openmgr/apiinfo/getAppApiSensitiveFields', params);
};
// 【接口日志】获取接口日志列表
export const getLogListAPI = (params: object) => {
    return API.GET('/req/logs/list', params, 'https://service.iclass30.com');
};
// 综评帮助中心-获取列表数据
export const getList = (params: object) => {
    return API.GET('/public/helpCenter/getList', params, process.env.VUE_APP_BASEAPIURL);
};

// 综评帮助中心-删除数据
export const del = (params: object) => {
    return API.GET('/public/helpCenter/del', params, process.env.VUE_APP_BASEAPIURL);
};
// 获取STS授权数据信息
export const getSTSTokenApi = (params: object)  => {
    return API.POST('/public/oss/getStsToken', params, process.env.VUE_APP_BASEAPIURL);
  };
  // 根据字典类别获取具体的条目——公共字典
export const findBaseDictList = (params: object) => {
    return API.GET('/userMgr/basedict/getDictList', params, process.env.VUE_APP_BASEAPIURL);
};
// 综评帮助中心-保存数据
export const save = (params: object) => {
    return API.POST('/public/helpCenter/save', params,process.env.VUE_APP_BASEAPIURL);
};